import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

export async function fetchMtrDetail(id) {
  const { data: raw } = await request.get(`/mtr/${id}`);
  return parseVer4DetailResponse(raw);
}
